module.exports = __webpack_public_path__ + "footer-rss-extra-small.cxQhy71r.svg";